export const service_url = process.env.NODE_ENV === 'production' ? 'https://sizeguide.sweetecom.com'
  : 'https://sizeguide.sweetecom.com';
export const url = process.env.NODE_ENV === 'production' ? 'https://sizeguide.sweetecom.com' : window.location.origin;
